<template>
  <div class="home">
    <el-row :gutter="24" type="flex">
      <el-col :span="8">
        <WrapBlock title="设备统计">
          <div class="totalDiv">
            <div class="label">总计</div>
            <div class="total">{{ formatNumWithComma(device.total, 0) }}</div>
            <div class="unit">台</div>
          </div>
          <div class="deviceCount" ref="deviceCount"></div>
        </WrapBlock>
      </el-col>
      <el-col :span="16">
        <WrapBlock title="规格型号">
          <div class="contentDiv" v-for="(item, index) in productModel.models" :key="index">
            <el-tooltip effect="dark" :content="item.name" placement="top">
              <div class="name">{{ item.name }}</div>
            </el-tooltip>
            <div class="progress">
              <el-progress
                :percentage="modelProgress[index]"
                :stroke-width="10"
                :show-text="false"
                color="#53BAFF"
              ></el-progress>
            </div>
            <div class="number">{{ formatNumWithComma(item.value, 0) }}</div>
            <div class="progressNumber">({{ item.progress }}%)</div>
          </div>
        </WrapBlock>
      </el-col>
    </el-row>
    <el-row :gutter="24" type="flex">
      <el-col :span="24">
        <WrapBlock title="探头故障统计">
          <el-button-group>
            <el-button
              :class="{ active: warn.type === 1 }"
              type="primary"
              plain
              @click="warnCount(1)"
              >7天</el-button
            >
            <el-button
              :class="{ active: warn.type === 2 }"
              type="primary"
              plain
              @click="warnCount(2)"
              >30天</el-button
            >
            <el-button
              :class="{ active: warn.type === 3 }"
              type="primary"
              plain
              @click="warnCount(3)"
              >年</el-button
            >
          </el-button-group>
          <div ref="warnCount" class="warnDiv"></div>
        </WrapBlock>
      </el-col>
    </el-row>
    <el-row :gutter="24" type="flex">
      <el-col :span="24">
        <WrapBlock title="其他故障统计">
          <el-button-group>
            <el-button
              :class="{ active: fault.type === 1 }"
              type="primary"
              plain
              @click="faultCount(1)"
              >7天</el-button
            >
            <el-button
              :class="{ active: fault.type === 2 }"
              type="primary"
              plain
              @click="faultCount(2)"
              >30天</el-button
            >
            <el-button
              :class="{ active: fault.type === 3 }"
              type="primary"
              plain
              @click="faultCount(3)"
              >年</el-button
            >
          </el-button-group>
          <div ref="faultCount" class="faultDiv"></div>
        </WrapBlock>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import WrapBlock from '@younuo/components/WrapBlock/index'
import { formatNumWithComma } from '@younuo/utils/utils'
let echarts = require('echarts')

export default {
  data() {
    return {
      device: {
        total: 0,
        onlineCount: 0,
        offlineCount: 0
      },
      productModel: {
        models: [],
        total: 0
      },
      warn: {
        type: 1
      },
      fault: {
        type: 1
      }
    }
  },
  mounted() {
    // 设备统计
    this.deviceCount()
    // 规格型号统计
    this.productModelCount()
    // 预警统计
    this.warnCount(this.warn.type)
    // 故障统计
    this.faultCount(this.fault.type)
  },
  computed: {
    modelProgress() {
      let progressArr = []
      for (let i = 0; i < this.productModel.models.length; i++) {
        if (this.productModel.total === 0 || this.productModel.models[i].value === 0) {
          progressArr.push(0)
        } else {
          progressArr.push(
            Math.round((this.productModel.models[i].value / this.productModel.total) * 100 * 100) /
              100
          )
        }
      }
      return progressArr
    }
  },
  methods: {
    deviceCount() {
      this.$ajax.get(this.$api.freezer.device_count).then((res) => {
        this.device = { ...res.data }

        let deviceCount = echarts.init(this.$refs.deviceCount)
        // 图表自适应
        window.addEventListener('resize', () => {
          deviceCount.resize()
        })

        deviceCount.setOption({
          tooltip: {
            trigger: 'item'
          },
          series: [
            {
              name: '设备统计',
              type: 'pie',
              radius: ['35%', '65%'],
              avoidLabelOverlap: false,
              itemStyle: {
                borderRadius: 10,
                borderColor: '#ffffff',
                borderWidth: 2
              },
              label: {
                alignTo: 'edge',
                formatter: '{time|{c}}\n{name|{b}}',
                minMargin: 5,
                edgeDistance: 10,
                lineHeight: 15,
                rich: {
                  time: {
                    fontSize: 14,
                    color: '#333333'
                  },
                  name: {
                    padding: [0, 0, 8, 0],
                    fontSize: 14,
                    color: '#999999'
                  }
                }
              },
              labelLine: {
                length: 15,
                length2: 120,
                maxSurfaceAngle: 80
              },
              data: [
                { value: this.device.onlineCount, name: '在线' },
                { value: this.device.offlineCount, name: '离线' }
              ]
            }
          ],
          color: ['#539CFF', '#FAB043']
        })
      })
    },
    productModelCount() {
      this.$ajax.get(this.$api.freezer.device_productModel_count).then((res) => {
        this.productModel = { ...res.data }
        for (let i = 0; i < this.productModel.models.length; i++) {
          if (this.productModel.total === 0 || this.productModel.models[i].value === 0) {
            this.productModel.models[i].progress = 0
          } else {
            this.productModel.models[i].progress =
              Math.round(
                (this.productModel.models[i].value / this.productModel.total) * 100 * 100
              ) / 100
          }
        }
      })
    },
    warnCount(type) {
      this.warn.type = type

      const params = {
        excType: '02',
        type: this.warn.type
      }
      this.$ajax.get(this.$api.freezer.alarm_line_count, params).then((res) => {
        let series = []
        res.data.yAxis.map((item) => {
          if (item.name.indexOf('探头') > -1) {
            series.push({
              name: item.name,
              type: 'bar',
              barWidth: 10,
              itemStyle: {
                opacity: 0.75
              },
              data: item.arr
            })
          }
        })

        let warnCount = echarts.init(this.$refs.warnCount)
        warnCount.clear()
        // 图表自适应
        window.addEventListener('resize', () => {
          warnCount.resize()
        })

        warnCount.setOption({
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            bottom: 10,
            itemWidth: 12,
            itemHeight: 8
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: 60,
            containLabel: true
          },
          yAxis: {
            type: 'value',
            minInterval: 1,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              fontSize: 14,
              color: '#999'
            }
          },
          xAxis: {
            type: 'category',
            data: res.data.xAxis,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              fontSize: 14,
              color: '#999'
            }
          },
          series: series,
          dataZoom: {
            type: 'inside'
          },
          color: ['#EC6161', '#FAB043', '#67D0FA', '#AF59D5', '#EF6DCB', '#539CFF']
        })
      })
    },
    faultCount(type) {
      this.fault.type = type

      const params = {
        excType: '02',
        type: this.fault.type
      }
      this.$ajax.get(this.$api.freezer.alarm_line_count, params).then((res) => {
        let series = []
        res.data.yAxis.map((item) => {
          if (item.name.indexOf('探头') === -1) {
            series.push({
              name: item.name,
              type: 'bar',
              barWidth: 28,
              stack: 'total',
              itemStyle: {
                opacity: 0.75
              },
              data: item.arr
            })
          }
        })

        let faultCount = echarts.init(this.$refs.faultCount)
        faultCount.clear()
        // 图表自适应
        window.addEventListener('resize', () => {
          faultCount.resize()
        })

        faultCount.setOption({
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            bottom: 10,
            itemWidth: 12,
            itemHeight: 8
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: 60,
            containLabel: true
          },
          yAxis: {
            type: 'value',
            minInterval: 1,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              fontSize: 14,
              color: '#999'
            }
          },
          xAxis: {
            type: 'category',
            data: res.data.xAxis,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              fontSize: 14,
              color: '#999'
            }
          },
          series: series,
          dataZoom: {
            type: 'inside'
          },
          color: ['#EC6161', '#FAB043', '#67D0FA', '#AF59D5', '#EF6DCB', '#539CFF']
        })
      })
    },
    formatNumWithComma
  },
  components: {
    WrapBlock
  }
}
</script>

<style lang="less" scoped>
.home {
  margin-top: 16px;
  width: 100%;
  .el-row {
    margin-bottom: 24px;
    min-width: 1100px;
    &:last-child {
      margin-bottom: 0;
    }
    .totalDiv {
      margin-top: 34px;
      text-align: center;
      .label {
        display: inline-block;
        margin-right: 12px;
        width: 32px;
        height: 32px;
        line-height: 32px;
        font-size: 14px;
        font-weight: bold;
        color: #ffffff;
        text-align: center;
        background-image: url('../../../assets/total_bg.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .total {
        font-family: Number-Bold;
        display: inline-block;
        margin-right: 4px;
        font-size: 36px;
        line-height: 36px;
        font-weight: bold;
        color: #333333;
        vertical-align: middle;
      }
      .unit {
        display: inline-block;
        font-size: 14px;
        font-weight: bold;
        color: #999999;
        vertical-align: bottom;
      }
    }
    .deviceCount {
      margin-top: 64px;
      height: 200px;
    }
    .contentDiv {
      display: flex;
      margin-top: 26px;
      line-height: 16px;
      font-size: 14px;
      color: #333333;
      .name {
        margin-top: -3px;
        margin-right: 20px;
        width: 150px;
        text-align: right;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .number {
        font-family: Number-Bold;
        margin: -3px 8px 0;
        font-size: 20px;
        font-weight: bold;
        color: #231815;
      }
      .progressNumber {
        margin-top: -3px;
        margin-right: 20px;
        min-width: 60px;
        font-size: 14px;
        color: #999999;
      }
      .progress {
        flex: 1;
        /deep/ .el-progress-bar {
          .el-progress-bar__outer {
            border-radius: 0;
          }
        }
        /deep/ .el-progress-bar__inner {
          background: rgb(32, 160, 255);
          border-radius: 0;
        }
      }
    }
    .el-button-group {
      float: right;
      margin-top: -42px;
      .el-button {
        background: #ffffff;
        border-color: #dcdcdc;
        color: #666666;
        &:hover {
          background: #005aab;
          border-color: #005aab;
          color: #ffffff;
        }
        &.active {
          background: #005aab;
          border-color: #005aab;
          color: #ffffff;
        }
      }
    }
    .warnDiv {
      width: 100%;
      height: 300px;
    }
    .faultDiv {
      width: 100%;
      height: 300px;
    }
  }
}
</style>
